import React from "react";
import styled, { keyframes } from "styled-components";

const Loader = ({ size, color, message = 'Loading...' }) => {
    return (
        <Wrapper>
            <StyledLoader size={size} color={color} />
            <h3 className="mt-4"> {message }</h3>
        </Wrapper>
    );
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
    text-align: center;
`;

const StyledLoader = styled.div`
    width: ${({ size }) => size + "px" || "50px"};
    height: ${({ size }) => size + "px" || "50px"};
    border: 4px solid ${({ color }) => color || "var( --main-color)"};
    border-top: 4px solid transparent;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    margin: auto;
`;

export default Loader;
